// src/features/users/components/UserServicesCard.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { UserService } from '../types/user.types';

export interface UserServicesCardProps {
  services: UserService[] | undefined;
}

const SERVICE_STATUS_LABEL: Record<UserService['status'], string> = {
  active: 'فعال',
  expired: 'منقضی شده',
  suspended: 'تعلیق شده',
};

/**
 * Workspace card: this user's services with their expiry date and
 * status. Rows come straight from the `services` prop — no fetching
 * here. Same list markup as
 * customers/components/CustomerServicesCard.tsx.
 */
export function UserServicesCard({ services }: UserServicesCardProps) {
  return (
    <Card className="vania-user-workspace-card vania-user-profile-full-width-card">
      <h2 className="vania-user-workspace-card-title">سرویس‌های فعال</h2>

      {services === undefined ? (
        <p className="vania-user-workspace-empty">اطلاعات سرویس‌ها در دسترس نیست.</p>
      ) : services.length === 0 ? (
        <p className="vania-user-workspace-empty">سرویسی برای این کاربر ثبت نشده است.</p>
      ) : (
        <div className="vania-user-profile-data-scroll">
          <div className="vania-user-profile-service-table" role="table" aria-label="سرویس‌های کاربر">
            <div className="vania-user-profile-service-row is-header" role="row">
              <span role="columnheader">سرویس</span>
              <span role="columnheader">انقضا</span>
              <span role="columnheader">وضعیت</span>
            </div>
            {services.map((service) => (
              <div key={service.id} className="vania-user-profile-service-row" role="row">
                <span className="vania-user-workspace-list-primary" role="cell">{formatPersianNumber(service.name)}</span>
                <span className="vania-user-workspace-list-secondary" role="cell" dir="ltr">{formatSolarDate(service.expiresAt)}</span>
                <span role="cell">
                  <span className={`vania-user-workspace-tag vania-user-workspace-tag-${service.status}`}>
                    {SERVICE_STATUS_LABEL[service.status]}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
